import React, { useState } from 'react';
import { Stack } from '@mui/system';
import { Box, Switch } from '@mui/material';
import { Typography, TextField, Grid } from '@mui/material';
import deleteIcon from '../../../Images/delete_red_icon.svg';
import infoIcon from '../../../Images/blue_info.svg';
import './CardView.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
	settrainingCenterID,
	showtrainingDetails,
} from '../../../redux/features/trainingCenter';
import { APP_ROUTES, FOMRS } from '../../../globals/constants';
import { useNavigate } from 'react-router-dom';

const CardView = (props) => {
	const navigate = useNavigate();

	const { lgWidth, res, ondeleteClick } = props;
	const dispatch = useDispatch();

	const editTraining = (e) => {
		e.stopPropagation();
	};

	const deleteTraining = (e, id) => {
		e.stopPropagation();
		ondeleteClick(id);
	};

	return (
		<>
			{res?.length > 0 ? (
				res?.map((res) => {
					let title = res?.studio_name;
					let titlelength = title?.length;
					let slicedTitle = title?.slice(0, 25);
					return (
						<Grid
							container
							direction="row"
							xs={12}
							sm={6}
							md={lgWidth}
							lg={lgWidth}
							xlg={lgWidth}
						>
							<Box
								sx={{
									width: '95%',
									m: '2%',
									backgroundColor: 'var(--mainBoxBG)',
									borderRadius: 1.5,
								}}
								className="cardViewTc"
								id="tc_CardView"
								onClick={() => {
									// setTainID(res.id);
									// console.log('name', res.id);
									// setShowDetails(true);
									dispatch(settrainingCenterID(res?.id));
									dispatch(showtrainingDetails(true));
								}}
							>
								<Stack direction="row" justifyContent="space-between">
									<Stack className="cd-fs-1" sx={{ mt: '4%', ml: '3%' }}>
										{titlelength > 25 ? `${slicedTitle}...` : res?.studio_name}
									</Stack>
									<Stack className="country fs-6 ">
										<Stack p={'2px'}>{res?.location?.address}</Stack>
									</Stack>
								</Stack>
								<Stack sx={{ m: '3%' }}>
									<span className="cd-fs">{res.created_at}</span>
								</Stack>
								<Stack direction="row">
									<Grid item xs={10}>
										<Box
											sx={{
												width: '95%',
												background: 'var(--subBoxBG)',
												m: 1,
												mt: 1,
												borderRadius: 1.5,
											}}
										>
											<Stack
												className="cardFontH2"
												justifyContent="space-between"
												direction="row"
											>
												<Stack className="cd-fs" marginTop="1%">
													No. of Scheduled Training :
												</Stack>
												<Stack className="cd-fs-1">{res.training_count}</Stack>
											</Stack>
										</Box>
										<Box
											sx={{
												width: '95%',
												background: 'var(--subBoxBG)',
												m: 1,
												borderRadius: 1.5,
											}}
										>
											<Stack
												className="cardFontH2"
												justifyContent="space-between"
												direction="row"
											>
												<Stack className="cd-fs" marginTop="1%">
													No. of Student Attended :
												</Stack>
												<Stack className="cd-fs-1">{res.student_count}</Stack>
											</Stack>
										</Box>
										<Box
											sx={{
												width: '95%',
												background: 'var(--subBoxBG)',
												m: 1,
												borderRadius: 1.5,
											}}
										>
											<Stack
												className="cardFontH2"
												justifyContent="space-between"
												direction="row"
											>
												<Stack className="cd-fs" marginTop="1%">
													No. of training Days :
												</Stack>
												<Stack className="cd-fs-1"> {res.training_days}</Stack>
											</Stack>
										</Box>
									</Grid>
									<Grid item xs={2}>
										<Box
											sx={{
												width: '90%',
												background: 'var(--subBoxBG)',
												m: 0,
												mt: 1,
												borderRadius: 1.5,
												height: '87%',
											}}
										>
											<Stack direction="column">
												<Stack
													direction="row"
													sx={{ justifyContent: 'center', p: '5%' }}
												>
													<Stack paddingTop="5%">
														<span className="cd-fs">Action</span>
													</Stack>
												</Stack>
												<Stack
													spacing={{ xs: '1%', md: '2%' }}
													sx={{
														justifyContent: 'center',
														p: { xs: '7%', sm: '30%' },
														paddingLeft: { xs: '30%' },
													}}
												>
													<Stack
														sx={{
															width: 16,
															height: 16,
															p: '2%',
															mt: '10%',
															ml: '0px',
															cursor: 'pointer',
														}}
													>
														<img
															src={infoIcon}
															alt=""
															onClick={(e) => {
																editTraining(e);
																navigate(APP_ROUTES.ADD_TRAINING_CENTRE, {
																	state: {
																		type: FOMRS.VIEW,
																		id: res.id,
																	},
																});
															}}
														/>
													</Stack>
													<Stack
														sx={{
															width: 16,
															height: 16,
															p: '2%',
															pt: '50%',
															ml: '5px',
															cursor: 'pointer',
														}}
													>
														<img
															src={deleteIcon}
															alt=""
															onClick={(e) => {
																deleteTraining(e, res.id);
															}}
														/>
													</Stack>
												</Stack>
											</Stack>
										</Box>
									</Grid>
								</Stack>
							</Box>
						</Grid>
					);
				})
			) : (
				<Stack className="NO_RECORD_FOUND">No Record Found</Stack>
			)}
		</>
	);
};

export default CardView;
